"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _richTextPlainTextRenderer = require("@contentful/rich-text-plain-text-renderer");
var createQuestionAnswerSchema = function createQuestionAnswerSchema(_ref) {
  var title = _ref.title,
    content = _ref.content,
    markAsFaq = _ref.markAsFaq;
  if (!markAsFaq) return null;
  return {
    '@type': 'Question',
    name: title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: (0, _richTextPlainTextRenderer.documentToPlainTextString)(content)
    }
  };
};
var _default = createQuestionAnswerSchema;
exports["default"] = _default;